import { Group, GroupPlan } from '@prisma/client'

export function isProPlan<TGroup extends Pick<Group, "plan"> | undefined> (group: TGroup) {
    return group?.plan !== GroupPlan.FREE && group?.plan !== GroupPlan.TRIAL;
}
